import { loadStripe, Stripe } from '@stripe/stripe-js'

const stripePromises = new Map<string, Promise<Stripe | null>>()

export function getStripePromise(publishableKey: string): Promise<Stripe | null> {
  let stripePromise = stripePromises.get(publishableKey)
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey)
    stripePromises.set(publishableKey, stripePromise)
  }
  return stripePromise
}



// WEBPACK FOOTER //
// ./src/libs/stripe/get-stripe-promise/index.ts